// inital JS load
(($) => {

    // when document ready,
    document.addEventListener('DOMContentLoaded', () => {
        const $directory = document.querySelector('.directory[data-view="faculty"]');
        if ( !$directory ) {
            return;
        }

        const $title = document.querySelector('.directory__results-title');
        const $typeFilter = document.querySelector('.directory__results-filter[data-type="search"]');
        let typeSearch = "";

        const $letterFilter = document.querySelector('.directory__results-filter[data-type="letter"]');
        let letterSearch = "";

        function searchRecords( term, letter ) {
            typeSearch = term;
            letterSearch = letter.toUpperCase();

            $typeFilter.querySelector('span').textContent = typeSearch;
            $letterFilter.querySelector('span').textContent = letterSearch;

            document.querySelectorAll('.directory__result').forEach( $el => {
                let matches = true;

                if ( letterSearch && $el.dataset.lname.toUpperCase() != letterSearch ) {
                    matches = false;
                }

                if ( matches && typeSearch && -1 == $el.dataset.search.toLowerCase().indexOf( typeSearch.toLowerCase() ) ) {
                    matches = false;
                }

                $el.setAttribute('data-visible', matches);
            } );

            const resultsCount = document.querySelectorAll('.directory__result[data-visible="true"]').length;
            $title.textContent = (!typeSearch && !letterSearch) ? "All Results" : resultsCount + " Result" + ( resultsCount != 1 ? "s" : "");
            
            $typeFilter.style.display = typeSearch == "" ? 'none' : 'flex';
            $letterFilter.style.display = letterSearch == "" ? 'none' : 'flex';

            document.querySelector('.directory__results-filters').setAttribute( 'data-has-results', !!(typeSearch || letterSearch) );
            document.querySelector('.directory__search-input input').value = typeSearch;
            document.querySelectorAll('[data-letter]').forEach($l=>$l.classList.remove('-isSelected'));
            
            if( letterSearch ) {
                document.querySelector('[data-letter="'+letterSearch+'"]').classList.add('-isSelected');
            }
        }
        
        let typeTimer = null;
        document.querySelector('.directory__search-input input').addEventListener( 'keyup', e => {
            if ( e.target.value.length < 3 ) {
                return;
            }

            if ( typeTimer ) {
                clearTimeout( typeTimer );
            }

            typeTimer = setTimeout( () => {
                searchRecords( e.target.value, letterSearch );
            }, 300 );
        });

        document.querySelector( '.directory__results-filters-clear' ).addEventListener( 'click', e => {
            e.preventDefault();
            searchRecords( '', '' );
        } );

        document.querySelector( '.directory__results-filter[data-type="search"]' ).addEventListener( 'click', e => {
            e.preventDefault();
            searchRecords( '', letterSearch );
        } );

        document.querySelector( '.directory__results-filter[data-type="letter"]' ).addEventListener( 'click', e => {
            e.preventDefault();
            searchRecords( typeSearch, '' );
        } );

        document.querySelectorAll( '[data-letter]' ).forEach( $e => $e.addEventListener( 'click', e => {
            e.preventDefault();
            searchRecords(typeSearch, e.target.dataset.letter);
        } ) );
        

    }, false);

})(jQuery);